// extracted by mini-css-extract-plugin
module.exports = {"body":"_5e09cdf"};